import { ReactNode } from 'react';

import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import DescriptionIcon from '@mui/icons-material/Description';
import EventNoteRoundedIcon from '@mui/icons-material/EventNoteRounded';
import InventoryIcon from '@mui/icons-material/Inventory';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import PaymentIcon from '@mui/icons-material/Payment';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import PersonIcon from '@mui/icons-material/Person';
import PointOfSaleRoundedIcon from '@mui/icons-material/PointOfSaleRounded';
import PrecisionManufacturingRoundedIcon from '@mui/icons-material/PrecisionManufacturingRounded';
import SettingsIcon from '@mui/icons-material/Settings';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import { SxProps } from '@mui/system';

import { AppPath } from '../constants/path';

const routeIcon: {
  [key in AppPath]?: {
    renderIcon: (sx?: SxProps) => ReactNode;
  };
} = {
  [AppPath.Customers]: {
    renderIcon: (sx?: SxProps) => <PeopleAltIcon sx={sx} />,
  },
  [AppPath.Orders]: {
    renderIcon: (sx?: SxProps) => <DescriptionIcon sx={sx} />,
  },
  [AppPath.Products]: {
    renderIcon: (sx?: SxProps) => <ShoppingBagIcon sx={sx} />,
  },
  [AppPath.Inventory]: {
    renderIcon: (sx?: SxProps) => <InventoryIcon sx={sx} />,
  },
  [AppPath.Bookings]: {
    renderIcon: (sx?: SxProps) => <CalendarTodayRoundedIcon sx={sx} />,
  },
  [AppPath.Payments]: {
    renderIcon: (sx?: SxProps) => <PaymentIcon sx={sx} />,
  },
  [AppPath.Checkout]: {
    renderIcon: (sx?: SxProps) => <PointOfSaleRoundedIcon sx={sx} />,
  },
  [AppPath.Shipping]: {
    renderIcon: (sx?: SxProps) => <LocalShippingRoundedIcon sx={sx} />,
  },
  [AppPath.Settings]: {
    renderIcon: (sx?: SxProps) => <SettingsIcon sx={sx} />,
  },
  [AppPath.Settings_UserSettings]: {
    renderIcon: (sx?: SxProps) => <PersonIcon sx={sx} />,
  },
  [AppPath.Settings_FulfilmentProviders]: {
    renderIcon: (sx?: SxProps) => <PrecisionManufacturingRoundedIcon sx={sx} />,
  },
  [AppPath.Settings_ShippingProviders]: {
    renderIcon: (sx?: SxProps) => <LocalShippingRoundedIcon sx={sx} />,
  },
  [AppPath.Settings_PaymentProcessors]: {
    renderIcon: (sx?: SxProps) => <EventNoteRoundedIcon sx={sx} />,
  },
  [AppPath.Settings_UsersManagement]: {
    renderIcon: (sx?: SxProps) => <PeopleAltRoundedIcon sx={sx} />,
  },
};

export default routeIcon;
